import type { IntlFormatters } from "@formatjs/intl/src/types";
import type { IProperty } from "types/jsonSchema";
import { z } from "zod";

export default function parseCvField(field: IProperty, formatMessage: IntlFormatters["formatMessage"] = () => "") {
    const fileObject = field.items?.properties?.id;
    const maxLength = fileObject?.["x-validators"].find((e) => e.validatorType === "filenameMaxLengthValidator")
        ?.length as number;

    const schema = z
        .object({
            id: z
                .string()
                .min(fileObject?.minLength ?? 1)
                .max(maxLength ?? 300),
        })
        .array()
        .min(field.minItems ?? 0, {
            error: formatMessage({ id: "cvFileRequired" }),
        });

    return schema;
}
